import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/features/auth/AuthContext';
import { SubNav, type SubNavItem } from './SubNav';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded';
import BackupRoundedIcon from '@mui/icons-material/BackupRounded';
import HistoryEduRoundedIcon from '@mui/icons-material/HistoryEduRounded';
import GavelRoundedIcon from '@mui/icons-material/GavelRounded';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import BuildRoundedIcon from '@mui/icons-material/BuildRounded';

export function AdminLayout(): JSX.Element {
  const { t } = useTranslation();
  const { user } = useAuth();
  const ADMIN_NAV: SubNavItem[] = [
    { to: '/admin', label: t('adminNav.overview'), icon: <DashboardRoundedIcon sx={{ fontSize: 16 }} />, end: true },
    { to: '/admin/config', label: t('admin.sections.config.title'), icon: <SettingsRoundedIcon sx={{ fontSize: 16 }} /> },
    { to: '/admin/dictionaries', label: t('admin.sections.dict.title'), icon: <MenuBookRoundedIcon sx={{ fontSize: 16 }} /> },
    { to: '/admin/backups', label: t('admin.sections.backups.title'), icon: <BackupRoundedIcon sx={{ fontSize: 16 }} /> },
    { to: '/admin/audit-log', label: t('admin.sections.audit.title'), icon: <HistoryEduRoundedIcon sx={{ fontSize: 16 }} /> },
    { to: '/admin/gdpr', label: t('admin.sections.gdpr.title'), icon: <GavelRoundedIcon sx={{ fontSize: 16 }} /> },
    { to: '/admin/tools', label: t('admin.sections.tools.title'), icon: <BuildRoundedIcon sx={{ fontSize: 16 }} /> },
  ];
  const navItems = ADMIN_NAV.filter((item) => {
    if (item.to === '/admin/gdpr') return user?.role === 'ADMIN' || user?.role === 'COORDINATOR';
    return user?.role === 'ADMIN';
  });

  return (
    <Box sx={{ mx: { xs: -2, md: -3 }, mt: { xs: -2.5, md: -3.5 } }}>
      <SubNav items={navItems} />
      <Box sx={{ px: { xs: 2, md: 3 } }}>
        <Outlet />
      </Box>
    </Box>
  );
}
